import { useIntl } from "react-intl";
import { useFormContext } from "react-hook-form";
import { StopType } from "types/MultiStop";
import FormItemInfo from "../../../Common/FormItemInfo";

interface StopPlanningSidebarProps {
  index: number;
  showHour: boolean;
  handleShowHour: () => void;
  showNotes: boolean;
  handleShowNotes: () => void;
}

export default function StopPlanningSidebar({
  index,
  showHour,
  handleShowHour,
  showNotes,
  handleShowNotes,
}: StopPlanningSidebarProps) {
  const intl = useIntl();

  const { watch } = useFormContext();
  const isPickup = watch(`schedule.stops.${index}.stop_type`) === StopType.PICKUP;

  return (
    <div className="mr-xl" style={{ minWidth: "200px" }}>
      <FormItemInfo labelId="general.schedule" label="Schedule" />
      <div className="cursor-pointer text-blue-200 font-b3 font-weight-bold mt-xs width-fit" onClick={handleShowHour}>
        {showHour
          ? `${
              isPickup
                ? intl.formatMessage({
                    id: "new-request.schedule.removePickupSpecifyHour",
                    defaultMessage: "Remove pickup hours",
                  })
                : intl.formatMessage({
                    id: "new-request.timing.removeDeliverySpecifyHour",
                    defaultMessage: "Remove delivery hours",
                  })
            }`
          : `${
              isPickup
                ? intl.formatMessage({
                    id: "new-request.schedule.addPickupSpecifyHour",
                    defaultMessage: "Add pickup hours",
                  })
                : intl.formatMessage({
                    id: "new-request.schedule.addDeliverySpecifyHour",
                    defaultMessage: "Add delivery hours",
                  })
            }`}
      </div>

      <div className="cursor-pointer text-blue-200 font-b3 font-weight-bold mt-xs width-fit" onClick={handleShowNotes}>
        {showNotes
          ? `${
              isPickup
                ? intl.formatMessage({
                    id: "new-request.schedule.removePickupInstruction",
                    defaultMessage: "Remove pickup instructions",
                  })
                : intl.formatMessage({
                    id: "new-request.schedule.removeDeliveryInstruction",
                    defaultMessage: "Remove delivery instructions",
                  })
            }`
          : `${
              isPickup
                ? intl.formatMessage({
                    id: "new-request.timing.addPickupInstructions",
                    defaultMessage: "Add pickup instructions",
                  })
                : intl.formatMessage({
                    id: "new-request.timing.addDeliveryInstructions",
                    defaultMessage: "Add delivery instructions",
                  })
            }`}
      </div>
    </div>
  );
}
